import { Controller } from '@hotwired/stimulus';

// The typed date (AppFormBuilder#date_input): dd/mm/aaaa, or dd/mm/aaaa hh:mm.
// Day first in every language the house speaks; the server (Fire::Dated)
// reads the same shape. Digits only, the separators come by themselves and
// only once a digit needs them, so backspace walks back over a "/" freely.
//
//   <input data-controller="date-input" data-date-input-time-value="true">
//
// A part of a date (a form that asks a day and two hours) names its own shape,
// "#" a digit, the rest glue: data-date-input-mask-value="##/##" or "##:##".
export default class extends Controller {
  static values = { time: { type: Boolean, default: false }, mask: String };

  connect() {
    this.onInput = () => this.fill();
    this.element.addEventListener('input', this.onInput);
  }

  disconnect() {
    this.element.removeEventListener('input', this.onInput);
  }

  fill() {
    if (this.hasMaskValue && this.maskValue) return this.fillMask();

    const digits = this.element.value.replace(/\D/g, '').slice(0, this.timeValue ? 12 : 8);
    const cuts = this.timeValue ? [2, 4, 8, 10] : [2, 4];
    const glue = { 2: '/', 4: '/', 8: ' ', 10: ':' };
    let out = '';
    for (let i = 0; i < digits.length; i += 1) {
      if (cuts.includes(i)) out += glue[i];
      out += digits[i];
    }
    if (out !== this.element.value) this.element.value = out;
  }

  fillMask() {
    const digits = this.element.value.replace(/\D/g, '');
    let out = '';
    let at = 0;
    for (const slot of this.maskValue) {
      if (at >= digits.length) break;
      if (slot === '#') {
        out += digits[at];
        at += 1;
      } else {
        out += slot;
      }
    }
    if (out !== this.element.value) this.element.value = out;
  }
}
